import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import {StyleSheet, Text} from 'react-native';
import {Icon} from 'react-native-elements';
import 'rsuite/dist/styles/rsuite-default.css';

type priceProps = {
  data: {tableHeader?: any[]; listData?: any[]};
  cellStyle: any;
  rowStyle: any;
};

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export const TableV = (props: priceProps) => {
  // const {data, cellStyle, rowStyle} = props;

  // const _getServices = (list: any[]) => {
  //   const _data: any = [];
  //   // eslint-disable-next-line no-unused-expressions
  //   Array.isArray(list) &&
  //     list.forEach(item => {
  //       console.log('list', item);
  //       _data.push(
  //         <TableRow key={item.title}>
  //           <TableCell style={StyleSheet.flatten(rowStyle)}>
  //             {item.title}
  //             <br />
  //             {item.subTitle}
  //           </TableCell>
  //           <TableCell align="right">
  //             {item?.icon1 ? <Icon icon={item.icon1} /> : null}
  //           </TableCell>
  //           <TableCell align="right">
  //             {item?.icon2 ? <Icon icon={item.icon2} /> : null}
  //           </TableCell>
  //           <TableCell align="right">
  //             {item?.icon3 ? <Icon icon={item.icon3} /> : null}
  //           </TableCell>
  //         </TableRow>,
  //       );
  //     });

  //   return _data;
  // };

  // const _getPlans = () => {
  //   const _dataHeader: any = [];
  //   // eslint-disable-next-line no-unused-expressions

  //   Array.isArray(data?.tableHeader) &&
  //     data?.tableHeader.forEach(ele => {
  //       _dataHeader.push(<TableCell style={{textAlign:'center'}}>{ele?.label}</TableCell>);
  //     });
  //   return (
  //     <TableHead>
  //       <TableRow style={StyleSheet.flatten(cellStyle)}>{_dataHeader}</TableRow>
  //       <TableBody>{_getServices(data?.dataList)}</TableBody>
  //     </TableHead>
  //   );
  // };

  // return (
  //   <TableContainer component={Paper}>
  //     <Table aria-label="customized table">{_getPlans()}</Table>
  //   </TableContainer>
  // );
  const styles = {
    headerStyle: {
      fontSize: 18,
      color: '#fff',
    },
  };
  return (
    <TableContainer style={{marginBottom: 20}}>
      <Table
        aria-label="spanning table"
        align="center"
        style={{
          width: '87%',
          borderLeft: '1px solid rgba(74,117,147, 0.1)',
          borderRight: '1px solid rgba(74,117,147, 0.1)',
          borderBottom: '1px solid rgba(74,117,147, 0.1)',
        }}
        // border={1}
      >
        <TableHead>
          <TableRow
            style={{
              // backgroundColor: '#F5F7FA',
              backgroundColor: '#4a7593',

              fontSize: 20,
              fontWeight: 'bold',
            }}
          >
            {props?.data?.tableHeader?.map(item => {
              return (
                <TableCell
                  align="center"
                  style={StyleSheet.flatten([styles.headerStyle])}
                >
                  {item?.label}
                </TableCell>
              );
            })}
            {/* <TableCell
              align="center"
              style={StyleSheet.flatten([styles.headerStyle])}
            >
              Feature Category
            </TableCell>
            <TableCell
              align="center"
              style={StyleSheet.flatten([styles.headerStyle])}
            >
              Feature
            </TableCell>
            <TableCell
              align="center"
              style={StyleSheet.flatten([styles.headerStyle])}
            >
              Bronze
            </TableCell>
            <TableCell
              align="center"
              style={StyleSheet.flatten([styles.headerStyle])}
            >
              Silver
            </TableCell>
            <TableCell
              align="center"
              style={StyleSheet.flatten([styles.headerStyle])}
            >
              Gold
            </TableCell>
            <TableCell
              align="center"
              style={StyleSheet.flatten([styles.headerStyle])}
            >
              Industry Example - Education
            </TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell rowSpan={7} style={{textAlign: 'center'}}>
              Issuer
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Issue - # of Credentials / Month
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              100
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              500
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              1000
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
          </TableRow>
          <TableRow style={{backgroundColor: '#F5F7FA'}}>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Delegate Credential Ownership
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Nomination
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              API
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Government ID Tax Employment
            </TableCell>
          </TableRow>
          <TableRow style={{backgroundColor: '#F5F7FA'}}>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Dashboard
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Network Operator Status
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
          </TableRow>
          <TableRow style={{backgroundColor: '#F5F7FA'}}>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Digital Signature
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Form Completion
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Credential Customization
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon
                name={'close-circle-outline'}
                type={'material-community'}
                color={'#d2d3d2'}
                size={30}
              />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'check-circle'} type={'feather'} color={'#3B7696'} />
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
          </TableRow>
          <TableRow style={{backgroundColor: '#F5F7FA'}}>
            <TableCell style={{textAlign: 'center'}}>Verifier</TableCell>
            <TableCell style={{textAlign: 'center'}}>
              Verify - # of Credential / Month{' '}
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              100
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              500
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              1000
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              KYC
            </TableCell>
          </TableRow>
          <TableRow style={{backgroundColor: '#3B7696'}}>
            <TableCell
              style={{textAlign: 'center', color: '#fff', fontWeight: 'bold'}}
            >
              Price / Month
            </TableCell>
            <TableCell
              style={{textAlign: 'center', color: '#fff', fontWeight: 'bold'}}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
            <TableCell
              style={{textAlign: 'center', color: '#fff', fontWeight: 'bold'}}
            >
              <Text
                style={{
                  lineHeight: 2,
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                $ 100 / month
              </Text>
            </TableCell>
            <TableCell
              style={{textAlign: 'center', color: '#fff', fontWeight: 'bold'}}
            >
              <Text
                style={{
                  lineHeight: 2,
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                $ 300 / month
              </Text>
            </TableCell>
            <TableCell
              style={{textAlign: 'center', color: '#fff', fontWeight: 'bold'}}
            >
              <Text
                style={{
                  lineHeight: 2,
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                Contact Us
              </Text>
            </TableCell>
            <TableCell
              style={{textAlign: 'center', color: '#fff', fontWeight: 'bold'}}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan={3} style={{textAlign: 'center'}}>
              Add-Ons
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Biometric Integration{' '}
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Video KYC (Face)
            </TableCell>
          </TableRow>
          <TableRow style={{backgroundColor: '#F5F7FA'}}>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Bundled Proof{' '}
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Complete KYC
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Passwordless
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              Contact Us
            </TableCell>
            <TableCell
              style={{
                textAlign: 'center',
                borderLeft: '1px solid rgba(74,117,147, 0.1)',
              }}
            >
              <Icon name={'dash'} type={'octicon'} color={'#d2d3d2'} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
